export type Option = { value: string; label: string };

type NetworkOption = { id: string; label: string };

// CONF-93 replaced the Ethernet/Infiniband toggle with Network Option x
// Protocol: the registry key is `networkOptions` and its entries are
// {id,label} objects, not strings; `networkProtocols` is a plain string list.

/** Pure option resolution for the Networking section — no React, so the hook
 *  is left to orchestrate state, derived ports and callbacks only. */
export function resolveNetworkingOptions(
  caps: Record<string, any>,
): { interfaceOptions: Option[]; protocolOptions: Option[] } {
  const interfaces = (caps.networkOptions ?? []) as NetworkOption[];
  const protocols = (caps.networkProtocols ?? []) as string[];
  return {
    interfaceOptions: interfaces.map((i) => ({ value: i.id, label: i.label })),
    protocolOptions: protocols.map((p) => ({ value: p, label: p })),
  };
}
